/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_OkInputs */

const en_tut_oscari_ok = /** @type {(inputs: Tut_Oscari_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A counter line says how many office results are shown, and closed rooms are marked **Ruang privat** or **Perlu akses**.`)
};

const id_tut_oscari_ok = /** @type {(inputs: Tut_Oscari_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baris hitungan menyebut berapa hasil kantor yang ditampilkan, dan ruang tertutup ditandai **Ruang privat** atau **Perlu akses**.`)
};

/**
* | output |
* | --- |
* | "A counter line says how many office results are shown, and closed rooms are marked **Ruang privat** or **Perlu akses**." |
*
* @param {Tut_Oscari_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_ok = /** @type {((inputs?: Tut_Oscari_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_ok(inputs)
	return en_tut_oscari_ok(inputs)
});